import React, { Component } from 'react';

export class LazyImage extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, error: false };
    }

    componentDidUpdate(prev) {
        if (prev.src !== this.props.src) {
            this.setState({ loaded: false, error: false });
        }
    }

    render() {
        var { src, alt, className, style, containerStyle } = this.props;
        var { loaded, error } = this.state;

        return (
            <div style={{ position: 'relative', overflow: 'hidden', background: '#eee', ...(containerStyle || {}) }}>
                {!loaded && !error && (
                    <div className="lazy-img-skeleton" style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="fas fa-image" style={{ color: 'rgba(0,0,0,0.15)', fontSize: '1.5em' }}></i>
                    </div>
                )}
                {error && (
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb' }}>
                        <i className="fas fa-image-slash" style={{ fontSize: '1.5em' }}></i>
                    </div>
                )}
                <img src={src} alt={alt || ''} className={className}
                    onLoad={() => this.setState({ loaded: true })}
                    onError={() => this.setState({ error: true })}
                    style={{ ...(style || {}), opacity: loaded ? 1 : 0, transition: 'opacity 0.35s ease' }}
                />
            </div>
        );
    }
}

export function LazyImageStyles() {
    return (
        <style>{`
            @keyframes lazy-skeleton-shimmer {
                0% { background-position: -200% 0; }
                100% { background-position: 200% 0; }
            }
            .lazy-img-skeleton {
                background: linear-gradient(90deg, #eee 0%, #f5f5f5 50%, #eee 100%);
                background-size: 200% 100%;
                animation: lazy-skeleton-shimmer 1.4s ease-in-out infinite;
            }
        `}</style>
    );
}
